import React, { useEffect, useState } from 'react';
import { Col, Row, Container, Button } from 'react-bootstrap';
import queryString from 'query-string';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import { formatMoney } from '../../utils/formatMoney';
import { wompiBaseUrl } from '../../utils/paymentKeys';
import './styles/landingStyles.scss';

function PaymentLandingComponent(props) {

  const [isLoading, setIsLoading] = useState(true);
  const [transactionStatus, setTransactionStatus] = useState('');
  const [amount, setAmount] = useState(0);
  let interval;

  useEffect(() => {
    const values = queryString.parse(props.location.search);
    const transactionId = values.id;

    interval = setInterval(
      async () => {
        checkTransaction(transactionId);
      },
      2000
    );
  }, []);

  const checkTransaction = async transactionId => {

    const transactionResponse = await fetch(`${wompiBaseUrl}/transactions/${transactionId}`);
    const transaction = await transactionResponse.json();
    const { data } = transaction;

    if (data && data.status !== 'PENDING') {
      clearInterval(interval);

      const { status, amount_in_cents } = data;
      const amount = parseInt(amount_in_cents) / 100;

      setTransactionStatus(status)
      setAmount(amount);
      setIsLoading(false);
    }

  };

  let TITLE, MESSAGE_1, MESSAGE_2, TOTAL_PAYED;

  if (transactionStatus === 'APPROVED') {
    TITLE = 'Transacción exitosa';
    MESSAGE_1 = 'Recibimos tu pago por un valor de ';
    MESSAGE_2 = '. La transacción fue exitosa.';
    TOTAL_PAYED = formatMoney(amount);
  } else {
    TITLE = 'Error en la transacción';
    MESSAGE_1 = 'Hubo un error al procesar la transacción. Por favor verifica la transacción con tu entidad bancaria o inténtalo nuevamente.';
    MESSAGE_2 = '';
    TOTAL_PAYED = '';
  }

  if (isLoading) {
    return (
      <div className="landing-spinner">
        <Container>
          <Row>
            <Col>
              <AppSpinner />
              <h4 className="message">
                Por favor espera mientras terminamos de procesar la transacción.
              </h4>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="payment-landing-component">
      <Container>
        <Row>
          <Col>
            <h1 className="title">{TITLE}</h1>
            <h4 className="message">{MESSAGE_1}{TOTAL_PAYED}{MESSAGE_2}</h4>

            <Button
              className="app-button"
              onClick={() => props.history.push('/')}
            >
              Aceptar
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PaymentLandingComponent;
